module.exports = __webpack_public_path__ + "static/media/icra25workshop.5dec6f96.jpeg";